<template>
  <div class="card-form">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('INDEX.form_label_base_info') || '基本信息'"
        name="base"
      >
        <edit-form
          ref="base"
          :cancelOrderCode="params.code"
          :orderCode="params.orderCode"
          :disabled="isDisableEditForm"
          :isAudit="isAudit"
          @saveOkQuestion="saveOkQuestion"
        />
        <div
          class="d-flex justify-content-end mt-2 mb-2"
          v-if="!isDisableEditForm && !isAudit"
        >
          <el-button type="primary" size="small" @click="save()">{{
            $l('INDEX.btn_save') || '保存'
          }}</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('form_label_title_order') || '订单信息'"
        name="info"
        lazy
      >
        <!-- <div class="side-frame group-title">
          <span>{{ this.$l('form_label_title_order') || '评审处理' }}</span>
        </div> -->
        <order-view ref="info" :orderCode="params.orderCode" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import { mapActions } from 'vuex'
export default {
  name: 'order-cancelRequest-detail',
  components: { EditForm },
  data() {
    return {
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
    //是审核操作模式
    isAudit() {
      return this.params.isAudit
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    onBeforeLeave() {
      return true
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    save() {
      this.$refs.base.save()
    },
  },
}
</script>
